import moment from "moment";

const getRelativeTimeFromNow = date => {
  return date ? moment(date).fromNow() : moment().fromNow();
};

export default getRelativeTimeFromNow;
